import { FC } from 'react';
import Conditions from '@/components/Icons/Conditions';
import Autofill from '@/components/Icons/Autofill';
import FilePDF from '@/components/Icons/FilePdf';
import Users from '@/components/Icons/Users';
import Tooltip from '@/components/Tooltip';
import s from './FormPreview.module.scss';

const TopLineButton: FC<{ type: 'conditions' | 'autofill' | 'assignees' | 'pdf-fill'; onClick: (e: React.MouseEvent) => void }> = ({ type, onClick }) => {
  let Icon;
  if (type === 'conditions') {
    Icon = Conditions;
  } else if (type === 'autofill') {
    Icon = Autofill;
  } else if (type === 'pdf-fill') {
    Icon = FilePDF;
  } else {
    Icon = Users;
  }
  return (
    <Tooltip text={`Show ${type}`} classNameTooltip={s.tooltip}>
      <button onClick={onClick} className={s.topLineButton}>
        <Icon size={12} color="var(--color-noodle)" />
      </button>
    </Tooltip>
  );
};

export default TopLineButton;
